import { Routes } from '@angular/router';
import { AuthGuard } from './_helpers/auth.guard';

import { AuthLayoutComponent } from './_layout/auth-layout/auth-layout.component';
import { AppMainLayoutComponent } from './_layout/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: AppMainLayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./_pages/home/home.routes').then(m => m.homeRoutes)
      },
      {
        path: 'companies',
        loadChildren: () => import('./_pages/companies/companies.routes').then(m => m.companiesRoutes)
      },
      {
        path: 'schools',
        loadComponent: () => import('./_pages/education/education.component').then(m => m.EducationComponent)
      },
      {
        path: 'regions',
        loadChildren: () => import('./_pages/regions/regions.routes').then(m => m.regionsRoutes)
      },
      {
        path: 'jobs',
        loadChildren: () => import('./_pages/jobs/jobs.routes').then(m => m.jobsRoutes)
      },
      {
        path: 'news',
        loadChildren: () => import('./_pages/news/news.routes').then(m => m.newsRoutes)
      },
      {
        path: 'about-us',
        loadChildren: () => import('./_pages/about/about.routes').then(m => m.aboutRoutes)
      },
      {
        path: 'people-and-groups',
        loadChildren: () =>
          import('./_pages/people-and-groups/people-and-groups.routes').then(m => m.peopleAndGroupsRoutes)
      },
      {
        path: 'career-success',
        loadChildren: () => import('./_pages/how-job-works/how-job-works.routes').then(m => m.howJobWorksRoutes)
      },
      {
        path: 'career-explorer',
        loadChildren: () => import('./_pages/career-explorer/career-explorer.routes').then(m => m.careerExplorerRoutes)
      },
      {
        path: 'my-favorites',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: 'job-match',
        loadChildren: () => import('./_pages/job-match/job-match.routes').then(m => m.jobMatchRoutes)
      },
      {
        path: 'info',
        loadChildren: () => import('./_pages/info/info.routes').then(m => m.infoRoutes)
      },
      { path: '', pathMatch: 'full', redirectTo: 'home' }
    ]
  },
  {
    path: 'auth',
    redirectTo: 'home',
    pathMatch: 'prefix'
  },
  {
    path: 'profile',
    redirectTo: 'home',
    pathMatch: 'prefix'
  }
];
